import { Directive, HostListener } from '@angular/core';
import { aplicarMascaraOnlyNumbers } from 'src/app/share/tools/mascara-only-numbers-tools';


@Directive({
  selector: '[appMaskOnlyNumbers]',
})
export class MaskOnlyNumbersDirective {
  constructor() {}

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {
    $event.target.value = aplicarMascaraOnlyNumbers($event.target.value);
  }
}
